var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"q-app"},on:{"contextmenu":function($event){return _vm.activePointer.apply(null, arguments)}}},[_c('router-view'),_c('Oops',{directives:[{name:"show",rawName:"v-show",value:(_vm.oops),expression:"oops"}],on:{"cancel":_vm.giveUp,"action":_vm.retry}}),_c('Overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }